import { memo } from 'react';

export interface FreespinsBadgeProps {
  count?: number;
  size?: 'sm' | 'md';
}

export const FreespinsBadge = memo(function FreespinsBadge({ count = 0, size = 'md' }: FreespinsBadgeProps) {
  if (!count) return null;
  const small = size === 'sm';
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: small ? 6 : 8,
        padding: small ? '4px 8px' : '5px 10px',
        background: 'var(--surface-2)',
        border: '1px solid var(--accent)',
        borderRadius: 999,
        fontFamily: 'Oswald, sans-serif',
        lineHeight: 1,
        boxShadow:
          '0 0 0 2px color-mix(in oklab, var(--accent) 18%, transparent)',
      }}
    >
      <span
        style={{
          fontSize: small ? 9 : 10,
          letterSpacing: 1.4,
          textTransform: 'uppercase',
          color: 'var(--text-muted)',
          fontWeight: 400,
        }}
      >
        Freespins
      </span>
      <span
        style={{
          fontSize: small ? 13.2 : 14.4,
          fontWeight: 400,
          color: 'var(--accent)',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {count}
      </span>
    </div>
  );
});
